import { render, staticRenderFns } from "./montilla-slot.vue?vue&type=template&id=08b4a0db"
import script from "./montilla-slot.vue?vue&type=script&lang=js"
export * from "./montilla-slot.vue?vue&type=script&lang=js"
import style0 from "./montilla-slot.vue?vue&type=style&index=0&id=08b4a0db&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports